import { AppInstall, Config } from 'src/apis/config'
import {
  ExternalLogin,
  Callback,
  LoginResult,
  CustomLoginParam,
} from './models'
import liff from '@line/liff'
import _ from 'lodash'
declare global {
  interface Window {
    appConnect: AppConnect
  }
}

export class AppConnect {
  config: Config | null = null
  loginInterface: ExternalLogin[] = []
  enableLogin: string[] = []

  init(config: Config) {
    console.log('[Privage] initial connect')
    this.config = config

    // Initial config
    config.apps.map((item) => {
      if (item.type === 0) {
        if (item.slug === 'line-oa') {
          this.enableLogin.push(item.slug)
          this.loginInterface.push({
            title: 'Log in with LINE',
            icon:
              'https://connect-loa.privageapp.com/images/2x/20dp/btn_base.png',
            color: '#00C300',
            id: item.slug,
          })
        }
      }
    })
  }

  loginIfNeed(to: string, cb: Callback<LoginResult>) {
    if (this.enableLogin.includes('line-oa')) {
      if (liff.isInClient()) {
        // Search line oa config
        const lineoa = _.find(
          this.config?.apps,
          (obj) => obj.slug === 'line-oa'
        )
        if (lineoa) {
          const liffApp = _.find(lineoa.config, (obj) => obj.key === to)
          if (liffApp) {
            liff
              .init({ liffId: liffApp?.value })
              .then(() => {
                if (liff.isLoggedIn()) {
                  cb('line-oa')
                } else {
                  liff.login()
                }
              })
              .catch(() => cb('login'))
          }
        }
      } else {
        cb('login')
      }
    } else {
      cb('login')
    }
  }

  getinstallAppConfig(slug: string): AppInstall | null {
    return _.find(this.config?.apps, (obj) => obj.slug === slug) || null
  }

  getLoginParam(slug: string): CustomLoginParam | null {
    if (slug === 'line-oa') {
      return <CustomLoginParam>{
        access_token: liff.getAccessToken(),
      }
    }

    return null
  }

  getLoginInterface(): ExternalLogin[] {
    return this.loginInterface
  }

  isDisableLogout(): boolean {
    if (this.enableLogin.includes('line-oa')) {
      if (liff.isInClient()) {
        return true
      }
    }

    return false
  }
}

export const appConnect = new AppConnect()

window.appConnect = appConnect
